module.exports = __webpack_public_path__ + "img/IMG_1169.694de446.jpg";